import React, { useEffect } from "react";

const CallbackHandler = () => {
  useEffect(() => {
    // Capture query params and redirect to /vkyc
    const search = window.location.search;
    window.location.href = "/vkyc" + search;
  }, []);

  return <div>Redirecting...</div>;
};

export default CallbackHandler;
